<script>
export default {
    name: 'IconRefresh'
}
</script>
<template>
    <svg
        class="base-icon icon-refresh"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 10c12.15 0 22 9.85 22 22s-9.85 22-22 22c-7.769 0-14.597-4.027-18.512-10.107l4.661-3.878C20.918 44.789 26.084 48 32 48c8.837 0 16-7.163 16-16s-7.163-16-16-16a15.958 15.958 0 00-11.823 5.22l5.983 3.45-13.666 3.657-3.66-13.646 6.056 3.492C18.92 13.187 25.088 10 32 10z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
